<template>
  <component
    :is="isLink ? 'a' : 'span'"
    :href="isLink ? url : undefined"
    :class="[classes, `logo_${theme}`, logoVariant && `variant-${logoVariant}`]"
    :data-preload="[$options.name]"
    @click="handleRootClick()"
  >
    <img
      class="logoSvg icon logoLarge qa-logo"
      :alt="`${theme || 'kfzteile24'} Logo`"
      width="180"
      :srcset="imgSrcset"
      :src="imgSrc"
    />
  </component>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import './images/logo_kfz24.png';
import './images/logo_kfz24--small.png';
import './images/logo_autoteile24.png';
import './images/logo_autoteile24--small.png';
import './images/logo_kfzteile-com.png';
import './images/logo_kfzteile-com--small.png';
import './images/logo_carpardoo.png';
import './images/logo_carpardoo--small.png';
import './images/logo_tirendo.png';
import './images/logo_tirendo--small.png';
// SVG
import './images/logo_kfzteile24.svg';
import './images/logo_kfzteile24_bplus.svg';
import './images/logo_kfzteile24_carpardoo.svg';
import './images/logo_kfzteile24_otc-1.svg';
import './images/logo_kfzteile24_otc-2.svg';
import './images/logo_kfzteile24_otc-3.svg';

import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'Logo',
  mixins: [globalMixin],
  props: {
    isLink: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      required: true,
    },
    theme: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('core', {
      salesChannelId: ({ salesChannel }) => salesChannel.salesChannelId,
      baseUrl: ({ salesChannel }) => salesChannel.baseUrl,
    }),
    ...mapGetters('core', ['isOTCSalesChannel']),
    iskfzteile24Theme() {
      return this.theme === 'kfzteile24';
    },
    logoVariant() {
      if (this.baseUrl?.includes('alpha')) {
        return 'bplus';
      }
      const scId = this.salesChannelId;
      if (scId?.includes('carpardoo')) {
        return 'carpardoo';
      } else if (this.isOTCSalesChannel) {
        const branch = scId?.match(/branch([1-3])/)?.[1];
        return branch ? `otc-${branch}` : '';
      }
      return '';
    },
    imgSrc() {
      let logoFile = `logo_${this.theme}`;
      let type = 'png';

      if (this.iskfzteile24Theme) {
        const variant = this.logoVariant;
        logoFile += variant !== '' ? `_${variant}` : '';
        type = 'svg';
      }
      return this.resolveFile(`images/logo/${logoFile}.${type}`);
    },
    imgSrcset() {
      if (this.iskfzteile24Theme) return undefined;

      return `${this.imgSrc} 4x, ${this.resolveFile(
        `images/logo/logo_${this.theme}--small.png`
      )} 1x`;
    },
  },
  methods: {
    handleRootClick() {
      if (this.isLink && this.url) {
        location.assign(this.url);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import 'variables/breakpoints';

.logo {
  max-height: 44px;
  max-width: 150px;
  overflow: hidden;
  display: block;
  object-fit: contain;
  cursor: pointer;

  &.logo_kfzteile24 {
    img {
      height: 60px;
    }

    &.variant-bplus,
    &.variant-otc-1,
    &.variant-otc-2,
    &.variant-otc-3 {
      img {
        height: 50px;
      }
    }

    &.variant-carpardoo img {
      height: 44px;
    }

    @media #{$_mediaLDown} {
      padding-top: 20px;

      img {
        height: 52px;
        margin-left: 0;
      }
    }

    @media #{$_mediaMDown} {
      overflow: auto;
      height: auto;
      padding-top: 0;

      img {
        height: 35px;
        margin-left: 0;
      }
    }
  }

  @media #{$_mediaMDown} {
    max-width: 115px;
  }

  @media #{$_mediaSDown} {
    height: 20px;
    width: 102px;

    &--newHeader {
      height: inherit;
      display: flex;
    }

    &.logo_tirendo {
      height: auto;
    }
  }
}

.logo_tirendo {
  width: 100%;
}

.logoSvg {
  width: 100%;
  height: auto;
  display: block;
  overflow: visible;
}

@media #{$_mediaMDown} {
  .logoSvg {
    margin: auto;
  }
}
</style>
